import React from "react";

export const PO_STATUSES = [
  "draft",
  "approved",
  "sent",
  "partially_received",
  "received",
  "closed",
  "cancelled",
];

export const PO_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  approved: "Approved",
  sent: "Sent",
  partially_received: "Partially Received",
  received: "Received",
  closed: "Closed",
  cancelled: "Cancelled",
};

export const PO_STATUS_BADGE_CLASS: Record<string, string> = {
  draft: "bg-slate-100 text-slate-700",
  approved: "bg-blue-50 text-blue-700",
  sent: "bg-indigo-50 text-indigo-700",
  partially_received: "bg-amber-50 text-amber-800",
  received: "bg-emerald-50 text-emerald-700",
  closed: "bg-slate-200 text-slate-600",
  cancelled: "bg-rose-50 text-rose-700",
};

export function purchaseOrderStatusLabel(status?: string) {
  if (!status) return "—";
  return PO_STATUS_LABELS[status] || String(status);
}

export function canReceivePurchaseOrder(status: string) {
  return ["approved", "sent", "partially_received"].includes(status);
}

export function canEditPurchaseOrder(status: string) {
  return ["draft", "approved"].includes(status);
}

export function canCancelPurchaseOrder(status: string) {
  return ["draft", "approved"].includes(status);
}

export function canSendPurchaseOrder(status: string) {
  return status === "approved";
}

export function canClosePurchaseOrder(status: string) {
  return ["approved", "sent", "partially_received", "received"].includes(
    status,
  );
}

export function canApprovePurchaseOrder(status: string) {
  return status === "draft";
}

export function canReopenPurchaseOrder(status: string) {
  return ["closed", "cancelled"].includes(status);
}

export function canDeletePurchaseOrder(
  _status: string,
  receivedAmount: string | number | null | undefined,
) {
  return Number(receivedAmount ?? 0) === 0;
}

export default function PurchaseOrderStatusBadge({ status }: any) {
  const label = purchaseOrderStatusLabel(status);
  const cls = PO_STATUS_BADGE_CLASS[status] || "bg-slate-100 text-slate-700";

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}
    >
      {label}
    </span>
  );
}
